import { ReactNode, MouseEventHandler } from 'react'
import { Box, Button, HStack, Placement, SystemStyleObject } from '@chakra-ui/react'
import { Icon as IconifyIcon } from './Icon'
import { Tooltip } from './Tooltip'

interface TinyActionProps {
  icon: string
  label: string
  leftLabel?: ReactNode
  onClick?: MouseEventHandler<HTMLButtonElement>
  placement?: Placement
  padding?: number | string
  iconSize?: number
  color?: string
  _hover?: SystemStyleObject
}

export const TinyAction = ({
  icon,
  label,
  leftLabel,
  onClick,
  placement,
  padding = 1,
  iconSize = 14,
  color,
  _hover,
}: TinyActionProps) => {
  const defaultHoverBg = 'bg.recess'
  const defaultHoverBorderColor = 'line.dark'
  const defaultIconColor = 'text.muted'

  const iconColor = color || defaultIconColor
  const hoverStyles = _hover || {
    bg: defaultHoverBg,
    borderColor: defaultHoverBorderColor,
  }

  return (
    <HStack spacing={1} className="group" cursor="pointer">
      {/*
        The text label shares the icon's action. Without its own handler the
        label looked clickable (the HStack sets cursor:pointer) but did nothing —
        only the small icon button fired. Wrapping it routes label clicks to the
        same onClick. Kept as a separate element from the button so neither
        double-fires.
      */}
      {leftLabel ? (
        <Box as="span" onClick={onClick} cursor={onClick ? 'pointer' : undefined}>
          {leftLabel}
        </Box>
      ) : null}
      <Tooltip label={label} placement={placement}>
        <Button
          size="xs"
          as={onClick ? 'button' : 'div'}
          variant="ghost"
          colorScheme="gray"
          border="1px solid transparent"
          borderRadius="full"
          onClick={onClick}
          aria-label={label}
          _groupHover={hoverStyles}
          _hover={hoverStyles}
          ml="auto"
          p={padding}
          minW="auto"
          w={6}
          h={6}
        >
          <IconifyIcon icon={icon} width={iconSize} height={iconSize} color={iconColor} />
        </Button>
      </Tooltip>
    </HStack>
  )
}
